const Wifi = () => (
  <svg
    width={18}
    height={15}
    viewBox="0 0 18 15"
    fill="none"
  >
    <path
      opacity={0.4}
      d="M9.19629 0.762939C5.79629 0.762939 2.82129 2.25044 0.696289 4.58794L9.19629 14.9296L17.6963 4.58794C15.5713 2.25044 12.5963 0.762939 9.19629 0.762939Z"
      fill="#5F6368"
    />
  </svg>
);
export default Wifi;
